import { Component, Output, EventEmitter, ViewChild, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QaiDialogComponent } from '@qai/ui';
import { CertificationUsersComponent } from 'src/app/pages/reporting-dashboard/dashboard-tabs/assignments-tab/certification-tab/certification-detail/certification-users/certification-users.component';
import { IUserCertificationDetail } from 'src/app/interfaces/reportingV2/icertification-users';
@Component({
  selector: 'app-certification-assignment-user-modal',
  standalone: true,
  imports: [CommonModule, QaiDialogComponent, CertificationUsersComponent],
  templateUrl: './certification-assignment-user-modal.component.html',
  styleUrls: ['./certification-assignment-user-modal.component.scss']
})
export class CertificationAssignmentUserModalComponent implements OnChanges{

  @ViewChild('certificationUsersDialog') qaiDialogRef: QaiDialogComponent | undefined;
  @Input() openUserModal = false;
  @Input() moduleAssignmentUuid: string = '';
  @Input() teamUuids: string[] = [];
  @Input() certificationStatus: string | null = null;
  @Input() userData: IUserCertificationDetail[] = [];
  @Input() isLoadingData: boolean = false;
  @Input() assignmentName: string = '';
  @Output() closeUserModal = new EventEmitter<void>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['openUserModal'] && this.qaiDialogRef) {
      this.openUserModal
        ? this.qaiDialogRef.showModal()
        : this.qaiDialogRef.close();
    }
  }

  handleCloseModal(): void {
    this.qaiDialogRef?.close();
    this.closeUserModal.emit();
  }
}
